declare var d3: any;
declare var solarCalculator: any;


import { Injectable } from '@angular/core';

@Injectable()
export class BrujulaService {

  constructor() { }


  buildVisualization(province) {
    function flippedStereographic(a, i)  {
      var cosa = Math.cos(a),
          cosi = Math.cos(i),
          k = 1 / (1 + cosa * cosi);
      return [ -k * cosi * Math.sin(a), k * Math.sin(i) ];
    }

    d3.selectAll("#svg1 > *").remove();

    var svg = d3.select("#svg1"),
        width = +svg.attr("width") - 26,
        height = +svg.attr("height") - 26,
        scale = width * .45;

    var formatTime = d3.time.format("%-I %p"),
        formatNumber = d3.format(".1f"),
        formatAngle = function(d) { return formatNumber(d) + "°"; };

    var projection = d3.geo.projection(flippedStereographic)
          .scale(scale)
          .clipAngle(130)
          .rotate([0, -90])
          .translate([width / 2 + 10.5, height / 2 + 10.5])
          .precision(.1);

    var path = d3.geo.path()
          .projection(projection);

    svg.append("path")
          .datum(d3.geo.circle().origin([0, 90]).angle(90))
          .attr("class", "horizon")
          .attr("d", path);

    svg.append("path")
          .datum(d3.geo.graticule())
          .attr("class", "graticule")
          .attr("d", path);

    var ticksAzimuth = svg.append("g")
          .attr("class", "ticks ticks--azimuth");

      //d3.select(self.frameElement).style("height", height + "px");

    ticksAzimuth.selectAll("text")
          .data(d3.range(0, 360, 10))
          .enter().append("text")
          .each(function(d) {
            var p = projection([d, -4]);
            d3.select(this)
                .attr("x", p[0])
                .attr("y", p[1]);
          })
          .attr("dy", ".35em")
          .text(function(d) { return d === 0 ? "N" : d === 90 ? "E" : d === 180 ? "S" : d === 270 ? "W" : d + "\u00B0"; });

      var solar = solarCalculator([2.17692, province.lat]);
      //var solar = solarCalculator([geolocation.coords.longitude, geolocation.coords.latitude]);

      svg.insert("path", ".sphere")
              .attr("class", "solar-path");

      var sun = svg.insert("g", ".sphere")
              .attr("class", "sun");

      sun.append("circle")
              .attr("r", 10);

      sun.append("text")
              .attr("class", "sun-label sun-label--azimuth")
              .attr("dy", ".71em")
              .attr("y", 12);

      sun.append("text")
              .attr("class", "sun-label sun-label--elevation")
              .attr("dy", "1.81em")
              .attr("y", 12);

      var tickSun = svg.insert("g", ".sphere")
              .attr("class", "ticks ticks--sun")
              .selectAll("g");

      refresh();

      //setInterval(refresh, 5000);

      function refresh() {
        var now = new Date,
            start = d3.time.day.floor(now),
            end = d3.time.day.offset(start, 1);

        svg.select(".solar-path")
                .datum({type: "LineString", coordinates: d3.time.minutes(start, end).map(solar.position)})
                .attr("d", path);

        sun.datum(solar.position(now))
                .attr("transform", function(d) { return "translate(" + projection(d) + ")"; });

        sun.select(".sun-label--azimuth")
                .text(function(d) { return formatAngle(d[0]) + " φ"; });

        sun.select(".sun-label--elevation")
                .text(function(d) { return formatAngle(d[1]) + " θ"; });

        tickSun = tickSun.data(d3.time.hours(start, end), function(d) { return +d; });

        tickSun.exit().remove();

        var tickSunEnter = tickSun.enter().append("g")
                .attr("transform", function(d) { return "translate(" + projection(solar.position(d)) + ")"; });

        tickSunEnter.append("circle")
                .attr("r", 2.5);

        tickSunEnter.append("text")
                .attr("dy", "-.31em")
                .attr("y", -6)
                .attr("style", function(d){var x= parseInt(d.toString().charAt(17)); if (x%2) return "opacity: 0;";})
                .text(formatTime);
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/ubicacion/brujula.service.ts